import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropArea", "preview", "hiddenInput", "deletedImagesContainer", "previewTemplate"];
  static values = { maxFiles: Number };

  declare readonly dropAreaTarget: HTMLDivElement;
  declare readonly previewTarget: HTMLDivElement;
  declare readonly hiddenInputTarget: HTMLInputElement;
  declare readonly deletedImagesContainerTarget: HTMLDivElement;
  declare readonly previewTemplateTarget: HTMLTemplateElement;
  declare readonly maxFilesValue: number;

  private filesArray: File[] = [];

  connect() {
    const highlight = () => {
      this.dropAreaTarget.classList.add('highlight')
    }

    const unhighlight = () => {
      this.dropAreaTarget.classList.remove('highlight')
    }

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      this.dropAreaTarget.addEventListener(eventName, this.preventDefaults, false)
    });


    ['dragenter', 'dragover'].forEach(eventName => {
      this.dropAreaTarget.addEventListener(eventName, highlight, false);
    });

    ;['dragleave', 'drop'].forEach(eventName => {
      this.dropAreaTarget.addEventListener(eventName, unhighlight, false);
    });

    this.dropAreaTarget.addEventListener('drop', this.handleDrop, false);
    this.dropAreaTarget.addEventListener('click', () => this.hiddenInputTarget.click());
    this.hiddenInputTarget.addEventListener('change', (e: any) => {
      if (e?.target?.files) {
        this.handleFileSelect(e?.target?.files);
        e.target.value = '';
      }
    });

    const existingImagesCount = this.element.querySelectorAll('.images-container .image-container').length;
    if ((this.filesArray.length + existingImagesCount) >= this.maxFilesValue) {
      this.dropAreaTarget.classList.add('hidden');
    }
  }

  disconnect() { }

  preventDefaults = (e: Event) => {
    e.preventDefault()
    e.stopPropagation()
  }

  handleDrop = (e: any) => {
    let dt = e.dataTransfer
    let files = dt.files

    this.handleFileSelect(files);
  }

  private handleFileSelect = (files: File[]) => {
    const existingImagesCount = this.element.querySelectorAll('.images-container .image-container').length;
    this.filesArray = Array.from(files).slice(0, Math.max(this.maxFilesValue - existingImagesCount, 0));

    this.filesArray.forEach(this.addNewImage);

    if ((this.filesArray.length + existingImagesCount) >= this.maxFilesValue) {
      this.dropAreaTarget.classList.add('hidden');
    } else {
      this.dropAreaTarget.classList.remove('hidden');
    }
  }

  private addNewImage = (file: File) => {
    if (!this.previewTemplateTarget) {
      return null
    }

    const clone = this.previewTemplateTarget.content.cloneNode(true) as HTMLElement;

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);

    const imageInputPlaceholder =  clone.querySelector<HTMLInputElement>('[data-img-input]');
    if (imageInputPlaceholder) imageInputPlaceholder.files = dataTransfer.files;

    const imgPlaceholder = clone.querySelector<HTMLImageElement>('[data-img]');
    if (imgPlaceholder) imgPlaceholder.src = URL.createObjectURL(file);

    const imgDeletePlaceholder = clone.querySelector<HTMLSpanElement>('[data-img-delete]');
    if (imgDeletePlaceholder) {
      imgDeletePlaceholder.onclick = (e: Event) => {
        const container = (e.currentTarget as HTMLSpanElement)?.closest('.images-container .image-container');
        if (container) {
          container.remove();
          this._toggleDropArea();
        }
      };
    }

    this.previewTarget.appendChild(clone.children[0]);
  }

  removeExistingImage(event: Event) {
    event.preventDefault();
    const button    = event.currentTarget as HTMLLinkElement;
    const imageId   = button.dataset.imageIdValue;

    if (imageId) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'delete_image_ids[]';
      input.value = imageId;
      this.deletedImagesContainerTarget.appendChild(input);
    }

    const container = button.closest('.images-container .image-container');
    if (container) {
      container.remove();
      this._toggleDropArea();
    }
  }

  removeTemporaryImage(event: Event) {
    event.preventDefault();

    const container = (event.currentTarget as HTMLLinkElement)?.closest('.images-container .image-container');
    if (container) {
      container.remove();
      this._toggleDropArea();
    }
  }

  _toggleDropArea() {
    const count = this.previewTarget.querySelectorAll('.images-container .image-container').length
    console.log(count);

    if (count < this.maxFilesValue) {
      this.dropAreaTarget.classList.remove('hidden');
    }
  }
}